var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import Chat from '@/components/chat/Chat';
import { Subject } from '@/models/Subject';
import { User } from '@/models/User';
import { RolesEnum } from '@/items/Roles';
let Messages = class Messages extends Vue {
    constructor() {
        super(...arguments);
        this.chatUserModel = new User().filter({ roles: [RolesEnum.TEACHER] });
    }
    mounted() {
        //
    }
};
__decorate([
    Prop({ default: () => new Subject() }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], Messages.prototype, "subject", void 0);
Messages = __decorate([
    Component({
        components: {
            Chat,
        },
    })
], Messages);
export default Messages;
